import { useState, useEffect,useRef } from "react";
import { useParams } from "react-router-dom";
import React from 'react';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { toast } from 'react-toastify';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import 'assets/css/themecustom-style.css';
import Select from 'react-select';
const axios = require("axios");
import jsPDF from "jspdf";
import "jspdf-autotable";
import myImage from "./Pdfdisplayimage.js";


const EditGovernanceCall = (props) => {
  
  const [clientdata, setClientdata] = useState([]);
  const [clientsearch, setclientsearch] = useState([{'label':'All Clients',value:'al_key_1'}]);
  const [disablestate, setdisablestate] = useState(false);
  const [disablestatebtn, setdisablestatebtn] = useState(false);
  const [disablestatebtn3, setdisablestatebtn3] = useState(false);

useEffect(() => {
  // get_unique_companieslist();
  get_user_client_list();
  getsingledata();
  // get_user_list();
  
}, []);

const months = [{value:'1',label : 'January'},{value:'2',label :'February'},{value:'3',label :'March'},{value:'4',label :'April'},{value:'5',label :'May'},{value:'6',label :'June'},{value:'7',label :'July'},{value:'8',label :'August'},{value:'9',label :'September'},{value:10,label :'October'},{value:11,label :'November'},{value:12,label :'December'}];
const [monthdata, setmonthdata] = useState(months);
let { id } = useParams();
const [uniquecompanieslist, setUniqueCompaniesData] = useState([]);
function get_unique_companieslist(department=''){
  clientmanageService.getuniqueclient(department).then((response)=>{
    setUniqueCompaniesData(response.data);
  });
}
const [userlist, setuserslist] = useState({'users':''});
const [clientlist, setclientlist] = useState({'clients':''});
function get_user_client_list(){
  clientmanageService.getusersclientlist().then((response)=>{
    setuserslist(response.data.users);
    //setclientlist(response.data)
  });
}
const ratings = [
  { value: '5', label: 'Very Happy' },
  { value: '4', label: 'Happy' },
  { value: '3', label: 'Neutral' },
  { value: '2', label: 'Not Happy' },
  { value: '1', label: 'Unhappy' },
];

const getRatingLabel = (ratingValue) => {
  const selectedRating = ratings.find(rating => rating.value == ratingValue);
  return selectedRating ? selectedRating.label : '';
};


const initialData = {
  client_id : '',
  month : '',
  action_items : [],
  notes : [],
  client_attendees : [],
  corient_attendees : []
  
}
const [inputFields, setInputfields] = useState(initialData);


function getsingledata(){
  clientmanageService.getgovernance(id).then((response) => {
    setInputfields(response.data.data)
    setRateBox(response.data.data.action_items.length)
    setOriginalRateBox(response.data.data.action_items.length)
    setNoteBox(response.data.data.notes.length)
    setCorientBox(response.data.data.corient_attendees.length)
    setClientBox(response.data.data.client_attendees.length)
    get_users_client(response.data.data.client_id)
    get_user_list(response.data.data.department)
  })
}

const [userlistData, setUserListData] = useState([]);
function get_user_list(department=''){
    clientmanageService.getusers(department).then((response) => {
    setUserListData(response.data.users)
  });
}

console.log(inputFields)
 function inputhandler1(e,field) {
  setInputfields((prevInputFields) => ({
    ...prevInputFields,
    [field]: e.value,
  }));

}
function inputhandler(e) {
  if(e.target.name == 'department'){
    get_unique_companieslist(e.target.value)
    get_user_list(e.target.value)
  }
  let phseup = {}
  phseup = { ...inputFields, [e.target.name]: e.target.value }    
  setInputfields(phseup);
}
  function setclient(e){ 
    setclientsearch(e.label);
    setClientdata([]);
    setInputfields((prevInputFields) => ({
      ...prevInputFields,
      ['client_id']: e.value,
    }));
   
  }

  const [ratebox, setRateBox] = useState(0);
  const [originalratebox, setOriginalRateBox] = useState(0);
 
  const addRatebox = ()=>{
    const setdata = ratebox+1;
    console.log('ss',setdata)
    setRateBox(setdata)
   
  }
  const removeRatebox = ()=>{
    if(ratebox > 0){
      const setdata = ratebox-1;
      setRateBox(setdata)
    }
  }
  const [notebox, setNoteBox] = useState(0);
 
  const addNotebox = ()=>{
    const setdata = notebox+1;
    setNoteBox(setdata)
   
  }
  const removeNotebox = ()=>{
    if(notebox > 0){
      const setdata = notebox-1;
      setNoteBox(setdata)
    }
  }
  const [corientbox, setCorientBox] = useState(0);
  const [label_disp_corient, setlablecorient] = useState(true);
  const [label_disp_client, setlableclient] = useState(true);
 
  const addCorientbox = ()=>{
    const setdata = corientbox+1;
    setCorientBox(setdata)
   
  }
  const removeCorientbox = ()=>{
    if(corientbox > 0){
      const setdata = corientbox-1;
      setCorientBox(setdata)
    }
  }
  const [client_users,setClientUsers]=useState([]);
  
function get_users_client(id=''){
  clientmanageService.getclientusers(id).then((response) => {
    const users = response.data;
    setClientUsers(users);

  });
}

  // function inputcorienthandler(e, index) {
  //   const { name, value } = e.target;
  //   const corient_attendees = [...inputFields.corient_attendees];
  //   if (!corient_attendees[index]) {
  //     corient_attendees[index] = {}; // Initialize the user object if it doesn't exist
  //   }
  //   corient_attendees[index] = value;
  //   setInputfields({ ...inputFields, corient_attendees });
  //   setlablecorient(false);
  // }

  function inputcorienthandler(selectedOption, index) {
    const corient_attendees = [...inputFields.corient_attendees];
  
    // Set selected value or empty string if cleared
    corient_attendees[index] = selectedOption ? selectedOption.value : '';
  
    setInputfields({ ...inputFields, corient_attendees });
    setlablecorient(false);
  }
  const [clientbox, setClientBox] = useState(0);
 
  const addClientbox = ()=>{
    const setdata = clientbox+1;
    setClientBox(setdata)
   
  }
  const removeClientbox = ()=>{
    if(clientbox > 0){
      const setdata = clientbox-1;
      setClientBox(setdata)
    }
  }
  
  // function inputclienthandler(e, index) {
  //   const { name, value } = e.target;
  //   const client_attendees = [...inputFields.client_attendees];
  //   if (!client_attendees[index]) {
  //     client_attendees[index] = {}; // Initialize the user object if it doesn't exist
  //   }
  //   client_attendees[index] = e.target.value;
  //   setInputfields({ ...inputFields, client_attendees });
  //   setlableclient(false);
  // }
  function inputclienthandler(selectedOption, index) {
    const client_attendees = [...inputFields.client_attendees];
  
    // Set selected value or empty string if cleared
    client_attendees[index] = selectedOption ? selectedOption.value : '';
  
    setInputfields({ ...inputFields, client_attendees });
    setlableclient(false);
  }

  function inputactionhandler(e, index) {
    const { name, value } = e.target;
    const action_items = [...inputFields.action_items];
    if (!action_items[index]) {
      action_items[index] = {}; // Initialize the user object if it doesn't exist
    }
    action_items[index][name] = value;
    setInputfields({ ...inputFields, action_items });
  }

  function inputactionhandlerselect(selectedOption, index) {
    const action_items = [...inputFields.action_items];
    
    if (!action_items[index]) {
      action_items[index] = {}; // Initialize if not present
    }
  
    action_items[index].responsibility = selectedOption ? selectedOption.value : '';
  
    setInputfields({ ...inputFields, action_items });
  }
  function inputnotehandler(e, index) {
    const { name, value } = e.target;
    const notes = [...inputFields.notes];
    if (!notes[index]) {
      notes[index] = {}; // Initialize the user object if it doesn't exist
    }
    notes[index][name] = value;
    setInputfields({ ...inputFields, notes });
  }
  const [item_vali, setItemVali] = useState([]);
    const validateItems = () => {
    if (inputFields.action_items.length > 0) {
      const errors = inputFields.action_items.map((item) => {
        return {
        remarks: item.remarks === '' || item.remarks === undefined,
        responsibility: item.responsibility === '' || item.responsibility === undefined,
        action_item: item.action_item === '' || item.action_item === undefined,
        target_date: item.target_date === '' || item.target_date === undefined,
      };
  
      });
  
      setItemVali(errors);
  
      const hasErrors = errors.some(err => Object.values(err).includes(true));
  
      if (hasErrors) {
        toast.error("Some fields are missing.");
      }
  
      return !hasErrors; 
    } else {
      toast.error("Action Item Required.");
      return false; 
    }
    };
  function editgovernancecall(e){
    let flag = e.target.value;
    
    e.preventDefault();
    if(validateItems()){
      if(flag==2){
      setdisablestatebtn(true)
      }else if(flag==3){
        setdisablestatebtn3(true)
      }
        else{
    setdisablestate(true)
      }
      clientmanageService.editgovernancetransdata(inputFields,flag).then((response)=>{
        
        if(response.status == 200){
          toast.success(response.data.message); 
        }else{
          console.log(response.data);
          toast.error(response.data.message);
        }
    
        setdisablestatebtn(false)
      
        setdisablestatebtn3(false)
      
        setdisablestate(false)
      
      });
    }
  }
  const getMonthName = (monthValue) => {
   
    const selectedMonth = months.find(month => month.value == monthValue);
    return selectedMonth ? selectedMonth.label : '';
  };
   // State for controlling PDF generation
   const [pdfData, setPdfData] = useState(null);

   // Function to handle PDF generation
   const generatePdf = () => {
    try {
      const doc = new jsPDF();
      
      const currentYear = new Date().getFullYear();
      const selectedMonthName = getMonthName(inputFields.month);

      // const selectedRatingLabel = getRatingLabel(inputFields.rating);
      // Add content to the PDF
      
      doc.addImage(myImage, 80, 0, 50, 20); // Replace with your image dimensions and position
      doc.text(`Governance Call month : ${selectedMonthName} ${currentYear}`, 20, 30);
      doc.text(`Client: ${inputFields.client_name}`, 20, 40);
      // doc.text(`Rating: ${selectedRatingLabel}`, 20, 50);
  
      let currentHeight = 60; // Initial height for the first page
  
      // Function to add attendees to the PDF
      const addAttendeesToPdf = (attendees, sectionTitle) => {
        doc.text(sectionTitle, 20, currentHeight);
        currentHeight += 10;
  
        attendees.forEach((attendee, index) => {
          doc.text(`${index + 1}. ${attendee}`, 30, currentHeight);
          currentHeight += 10;
  
          // Check if adding another line will exceed the page height
          if (currentHeight + 10 > doc.internal.pageSize.height) {
            doc.addPage(); // Start a new page
            currentHeight = 20; // Reset the height for the new page
          }
        });
  
        currentHeight += 10; // Add extra space between sections
      };

      // const client_attendees = inputFields.client_attendees.map(value => {
      //   const foundItem = userlist.clients.find(item => item.value === parseInt(value));
      //   return foundItem ? foundItem.label : null;
      // });

     const corient_attendees = inputFields.corient_attendees.map(value => {
      const foundItem = userlist.find(item => item.value === parseInt(value));
      return foundItem ? foundItem.label : null;
    });

    
      // Add Client attendees
      addAttendeesToPdf(inputFields.client_attendees, "Client Attendees");

       // Add Corient attendees
       addAttendeesToPdf(inputFields.corient_attendees, "Corient Attendees");
       doc.text("Action Item", 20, currentHeight);
       const headers = ['Action Item', 'Responsibility', 'Target date','Remarks'];
       const columnsToDisplay = ['action_item', 'responsibility','target_date', 'remarks'];

   
       currentHeight += 5;
       // Add table headers
       doc.autoTable({ startY: currentHeight, head: [headers], margin: { horizontal: 20 } });
       currentHeight += 7;
      const data = inputFields.action_items.map((item) => columnsToDisplay.map((column) => item[column]));
      doc.autoTable({ startY: currentHeight, body: data, margin: { horizontal: 20 } });

      currentHeight += (inputFields.action_items.length==1) ? 25 : ((inputFields.action_items.length * 10) / 2) + 30;
      // inputFields.action_items.forEach((item, index) => {console.log("dd")
      //   //doc.text(`${index + 1}. ${item.action_item}`, 30, currentHeight);

      //   currentHeight += 20;
  
      //   // Check if adding another line will exceed the page height
      //   if (currentHeight + 10 > doc.internal.pageSize.height) {
      //     doc.addPage(); // Start a new page
      //     currentHeight = 20; // Reset the height for the new page
      //   }
      // });

      // Add Notes
      doc.text("Notes", 20, currentHeight);
      currentHeight += 5;
      console.log(inputFields.notes)
      const noteheaders = ['Id', 'Note'];
 
    const newArray = inputFields.notes.map((item, index) => {
          return {
            ...item,
            id: index + 1,
          }
      });
      doc.autoTable({ startY: currentHeight, head: [noteheaders], margin: { horizontal: 20 } });
       currentHeight += 7;
       doc.autoTable({ startY: currentHeight, body: newArray, margin: { horizontal: 20 } });
      
  
      // Save the PDF
      // doc.save("minutes_of_meeting.pdf");
      // Get the raw PDF data
      const pdfData = doc.output('blob');

      // Create a Blob from the PDF data
      const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
  
      // Create a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
  
      // Open the PDF in a new window
      window.open(pdfUrl, '_blank');
  
      // Open the print dialog
      // window.print();
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };
  
  const selectedMonthName = getMonthName(inputFields.month);
  function inputactionresphandler(e, index){
   
    const action_items = [...inputFields.action_items];
    if (!action_items[index]) {
      action_items[index] = {}; // Initialize the user object if it doesn't exist
    }
    action_items[index]['responsibility'] = e.value;
    setInputfields({ ...inputFields, action_items });
  }
  return (
    <>
      <Header />
      <Container className="mt--7"  fluid>
    
        <Row className="mt-5">
       
          <div className="col" style={{padding:'0%'}}>
              
            <Card className="shadow">
            <Button
                      className="col-2 mt-2"
                      color="success"
                      onClick={generatePdf}
                    >
                      Generate PDF
                    </Button>
                    <br></br>
            <Form role="form" id="adduser-form" onSubmit={editgovernancecall}>
              <CardHeader className="border-0">
              <Row >
                
              <div className="col-xl-3 col-md-4 col-xs-12">
                    <FormGroup>
                        <label>Governance call month : {selectedMonthName}</label>
                      
                      </FormGroup> 
                    <label className="clientformtag"> Client : {inputFields.client_name}</label>
                    
                    </div>
                    <div className="col-xl-3 col-md-4 col-xs-12">
                    <FormGroup>
                        <label> call date : {inputFields.date}</label>
                      
                      </FormGroup> 
                    
                    </div>

                    
                  <div className="col-xl-3 col-md-2 col-xs-12">
                    <FormGroup>
                        <label>Department : {inputFields.department}</label>
                       
                      </FormGroup> 
                  </div>
                  <div className="col-xl-3 col-md-2 col-xs-12">
                    <FormGroup>
                        <label>Rating</label>
                        <select class="form-control" name="rating" value={inputFields.rating}  onChange={(e) => inputhandler(e)} required>
                              <option value=""> Select Overall Satisfaction Level</option>
                                {/* <option value="5">Very Happy</option> */}
                                <option value="5">Happy</option>
                                {/* <option value="3">Neutral</option> */}
                                <option value="1">Not Happy</option>
                                {/* <option value="1">Unhappy</option> */}
                                <option value="0">No Show</option>
                              </select>
                      </FormGroup> 
                  </div>
                  <div className="col-xl-3 col-md-2 col-xs-12">
                    <FormGroup>
                        <label>Meeting Title</label>
                        <Input
                     placeholder="Meeting Title"
                     type="text"
                     name="meeting_title"
                     onChange={(e) => inputhandler(e)}
                     value={inputFields.meeting_title}
                     required
                   />
                      </FormGroup> 
                  </div>
                    <br></br>
                  <div className="col-md-12">&nbsp;</div>
                  {(() => {
            const arr1 = [];
            for (let k = 0; k < corientbox; k++) {
                arr1.push(
                 <>
                    
                    <div className="col-md-3">
                       <FormGroup>
                       {/* <label>Level</label> */}
                       <div className="row">
                     
                  <div className="col-xl-10 col-md-12 col-xs-12">
                    <FormGroup>
                        <label>Name</label>
                        <div className="d-flex">
                        {(userlist && userlist.length > 0)?
                        
                        <InputGroup className="input-group-alternative mb-3">
                        
                          <Select
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder="Select user manager for reporting"
                            name="team_user"
                            value={userlist.find(option => option.value === inputFields.corient_attendees[k]) || null}
                            options={userlist}
                            onChange={(selectedOption) => inputcorienthandler(selectedOption, k)}
                            isClearable
                            isSearchable
                          />
                            {/* <select className="form-control" name="team_user" placeholder="User" value={inputFields.corient_attendees[k] ? inputFields.corient_attendees[k] : ''} onChange={(e) => inputcorienthandler(e, k)}>
                              <option key="user_1"  value="">Select user manager for reporting</option>
                              {userlist.map(team =>
                                  <option key={team.value} value={team.value}>{team.label}</option>
                              )}
                            </select> */}
                           
                          </InputGroup>
                          
                        
                        
                    //   <Select 
                    
                    //   className="input-group-alternative mb-3" 
                    //   name="name"
                    //   options={userclientlist['users']} // set list of the data
                    //   value={inputFields.corient_attendees[k] ? inputFields.corient_attendees[k] : ''}
                    //   searchable
                    //   onChange={(e) => inputcorienthandler(e, k)}
                    //   isClearable={false}
                    // />
                    
                          : null }
                          {/* {(!inputFields.corient_check) && (label_disp_corient) ? 
                        <span style={{'line-height': '35px','margin-left':'10px'}}>{inputFields.corient_attendees[k]}</span>: null } */}
                        </div> 
                      </FormGroup>      
                  </div>

                 
                    
                    <Col md="1">
        {k >= inputFields.corient_attendees.length && (
        <button
        type="button"
          className="btn btn-danger"
          onClick={() => removeCorientbox(k)}
        >
          <i className="fa fa-remove"></i>
        </button>
       )} 
    </Col>
                        </div>
                      </FormGroup>    
                    </div> 
                    </>
                );
            }
            return arr1;
            
        })()}
                    <Col md="12" style={{marginBottom:"10px"}}>
            <a className="btn btn-info"  onClick={(e) => addCorientbox()}>+ Add Corient Attendees </a>
          </Col>
               

          <br></br>
                  <div className="col-md-12">&nbsp;</div>
                  {(() => {
            const arr1 = [];
            for (let k = 0; k < clientbox; k++) {
                arr1.push(
                 <>
                    
                    <div className="col-md-3">
                       <FormGroup>
                       {/* <label>Level</label> */}
                       <div className="row">
                     
                  <div className="col-xl-10 col-md-12 col-xs-12">
                    <FormGroup>
                        <label>Name</label>

                        {client_users && client_users.length > 0 ? (
                         
                          <Select
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="Select client user"
                          name="team_user"
                          value={client_users.find(option => option.value === inputFields.client_attendees[k]) || null}
                          options={client_users}
                          onChange={(selectedOption) => inputclienthandler(selectedOption, k)}
                          isClearable
                          isSearchable
                        />
                        ) : null}
                      </FormGroup>
                        {/* {(clientlist && clientlist['clients'].length > 0)?
                      
                      <InputGroup className="input-group-alternative mb-3">
                            <select className="form-control" name="name" placeholder="Client" value={inputFields.client_attendees[k] ? inputFields.client_attendees[k] : ''} onChange={(e) => inputclienthandler(e, k)}>
                              <option key="user_1"  value="">Select Client</option>
                              {userlist['clients'].map(client =>
                                  <option key={client.value} value={client.value}>{client.label}</option>
                              )}
                            </select>
                          </InputGroup>
                    //   <Select 
                    
                    //   className="input-group-alternative mb-3" 
                    //   name="name"
                    //   options={userclientlist['clients']} // set list of the data
                    //   defaultValue={inputFields.client_attendees[k] ? inputFields.client_attendees[k] : ''}
                    //   value={{label: amendmentdata.am_company_name,value: amendmentdata.am_company}}
                    //   searchable
                    //   onChange={(e) => inputclienthandler(e, k)}
                    //   isClearable={false}
                    // />
                          : null }
                          {(!inputFields.client_check) && (label_disp_client) ? 
                        <span style={{'line-height': '35px','margin-left':'10px'}}>{inputFields.client_attendees[k]}</span>: null } */}
                         
                  </div>
                 
                    
                    <Col md="1">
      {k >= inputFields.client_attendees.length && (
        <button
        type="button"
          className="btn btn-danger"
          onClick={() => removeClientbox(k)}
        >
          <i className="fa fa-remove"></i>
        </button>
       )}
    </Col>
                        </div>
                      </FormGroup>    
                    </div> 
                    </>
                );
            }
            return arr1;
            
        })()}
                    <Col md="12" style={{marginBottom:"10px"}}>
            <a className="btn btn-info"  onClick={(e) => addClientbox()}>+ Add Client Attendees </a>
          </Col>
               

                  <br></br>
                  <div className="col-md-12">&nbsp;</div>
                  {(() => {
            const arr1 = [];
            for (let k = 0; k < ratebox; k++) {
                arr1.push(
                 <>
                    
                    <div className="col-md-12">
                       <FormGroup>
                       {/* <label>Level</label> */}
                       <div className="row">
                       <div className="col-xl-3 col-md-2 col-xs-12">
                       <FormGroup>
                        <label>Feedback</label>
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            placeholder="Feedback"
                            type="text"
                            name="remarks"
                            defaultValue={inputFields.action_items[k] ? inputFields.action_items[k].remarks : ''}
                            onChange={(e) => inputactionhandler(e, k)}
                            className={item_vali[k]?.remarks ? 'input-error' : ''}
                          />
                        </InputGroup>
                      </FormGroup> 
                    
                  </div>
                  <div className="col-xl-3 col-md-2 col-xs-12">
                    <FormGroup>
                        <label>responsibility</label>
                        {
                          <Select 
                    
                         className={
  "input-group-alternative mb-3" +
  (item_vali[k]?.responsibility ? " input-error" : "")
}
                         name="responsibility"
                         options={userlistData} // set list of the data
                        //  defaultValue={inputFields.action_items[k] ? inputFields.action_items[k].responsibility : ''}
                         value={
                          userlistData.find(
                            option => option.value === inputFields.action_items[k]?.responsibility
                          ) || null
                        }
                         searchable
                         onChange={(selectedOption) => inputactionhandlerselect(selectedOption, k)}
                         isClearable={false}
                       />
                       }
                      </FormGroup> 
                  </div>
                  <div className="col-xl-2 col-md-2 col-xs-12">
                    <FormGroup>
                        <label>Target date</label>
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            placeholder="Target date"
                            type="date"
                            name="target_date"
                            defaultValue={inputFields.action_items[k] ? inputFields.action_items[k].target_date : ''}
                            onChange={(e) => inputactionhandler(e, k)}
                            className={item_vali[k]?.target_date ? 'input-error' : ''}
                          />
                        </InputGroup>
                      </FormGroup> 
                  </div>
                       
                  <div className="col-xl-3 col-md-2 col-xs-12">
                  <FormGroup>
                        <label>Action Item</label>
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            placeholder="Action Item"
                            type="text"
                            name="action_item"
                            defaultValue={inputFields.action_items[k] ? inputFields.action_items[k].action_item : ''}
                            onChange={(e) => inputactionhandler(e, k)}
                            className={item_vali[k]?.action_item ? 'input-error' : ''}
                          />
                        </InputGroup>
                      </FormGroup>    
                  </div>

                 
                    
                    <Col md="1">
                    <br></br>
        {k >= inputFields.action_items.length && (
        <button
        type="button"
          className="btn btn-danger"
          onClick={() => removeRatebox(k)}
        >
          <i className="fa fa-remove"></i>
        </button>
       )} 
    </Col>
                        </div>
                      </FormGroup>    
                    </div> 
                    </>
                );
            }
            return arr1;
            
        })()}
                    <Col md="12" style={{marginBottom:"10px"}}>
            <a className="btn btn-info"  onClick={(e) => addRatebox()}>+ Add action items </a>
          </Col>

          <br></br>
                  <div className="col-md-12">&nbsp;</div>
                  {(() => {
            const arr1 = [];
            for (let k = 0; k < notebox; k++) {
                arr1.push(
                 <>
                    
                    <div className="col-md-12">
                       <FormGroup>
                       {/* <label>Level</label> */}
                       <div className="row">
                     
                  <div className="col-xl-10 col-md-12 col-xs-12">
                    <FormGroup>
                        {/* <label>Note</label> */}
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            placeholder="Note"
                            type="textarea"
                            name="note"
                            defaultValue={inputFields.notes[k] ? inputFields.notes[k].note : ''}
                            onChange={(e) => inputnotehandler(e, k)}
                            required
                          />
                        </InputGroup>
                      </FormGroup>      
                  </div>

                 
                    
                    <Col md="1"><br></br>
        {k >= inputFields.notes.length && (
        <button
        type="button"
          className="btn btn-danger"
          onClick={() => removeNotebox(k)}
        >
          <i className="fa fa-remove"></i>
        </button>
      )} 
    </Col>
                        </div>
                      </FormGroup>    
                    </div> 
                    </>
                );
            }
            return arr1;
            
        })()}
                    {/* <Col md="12" style={{marginBottom:"10px"}}>
            <a className="btn btn-info"  onClick={(e) => addNotebox()}>+ Add Notes </a>
          </Col> */}
               
                </Row>

                
                <div className="col-md-12">
                        <label>&nbsp;</label>
                        <Button className="col-2 " color="primary" value={0} onClick={(e) => editgovernancecall(e)} disabled={disablestate}>
                          {disablestate ? 'Sending...' : 'Save'} 
                         </Button>
                         <Button className="col-2 " color="primary" type="submit" value={2} onClick={(e) => editgovernancecall(e)} disabled={disablestatebtn}>
                          {disablestatebtn && disablestatebtn==2 ? 'Sending...' : 'Save & Mail to Internal Team'} 
                        </Button>
                        <Button className="col-2 " color="primary" type="submit" value={3} onClick={(e) => editgovernancecall(e)} disabled={disablestatebtn3}>
                          {disablestatebtn3 && disablestatebtn3==3 ? 'Sending...' : 'Save & Mail to External Team'} 
                        </Button>
                       
                    </div>
                    
              </CardHeader>
              </Form>
             </Card>
             </div>
             
        </Row>
      </Container>
    </>
  );
};


export default EditGovernanceCall;
